export default "__VITE_ASSET__ecKcH2Mt__"